import styled from "@emotion/styled";
import MUISkeleton from "@mui/material/Skeleton";

const Skeleton = styled(MUISkeleton)``;

function Creator(props) {
	return (
		<div className={props.className}>
			<Skeleton variant="rounded" height={65} width="100%" />
			<Skeleton variant="rounded" height={65} width="100%" />
			<Skeleton variant="rounded" height={65} width="100%" />
			<Skeleton variant="rounded" height={65} width="100%" />
		</div>
	);
}

export default styled(Creator)`
  padding: 0 12px 12px;

  ${Skeleton} {
    margin-bottom: 12px;
  }

  > div:last-child {
    display: flex;
    align-items: center;
    justify-content: center;

    > ${Skeleton} {
      border-radius: 48px;
    }
  }
`;
